"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
//@ts-ignore
require("../theme.ts");
var Drawer = /** @class */ (function (_super) {
    __extends(Drawer, _super);
    function Drawer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMaskClick = function () {
            _this.fire('close');
        };
        return _this;
    }
    Drawer.prototype.render = function (props) {
        return (omi_1.h("div", __assign({}, omi_1.extractClass(props, 'm-drawer', {
            'm-drawer-show': props.show
        })),
            omi_1.h("div", { class: 'ctn', style: "transform: " + this._getTransfrom(props.position) },
                omi_1.h("slot", null)),
            omi_1.h("div", { class: "mask", onClick: this.onMaskClick })));
    };
    Drawer.prototype._getTransfrom = function (position) {
        if (position === 'left') {
            return "translateX(" + (this.props.show ? '0' : '-100') + "%);top:0;";
        }
        if (position === 'right') {
            return "translateX(" + (this.props.show ? '0' : '100') + "%);right:0;top:0;";
        }
        if (position === 'top') {
            return "translateY(" + (this.props.show ? '0' : '-100') + "%);top:0;";
        }
        if (position === 'bottom') {
            return "translateY(" + (this.props.show ? '0' : '100') + "%);bottom:0;";
        }
    };
    Drawer.css = css;
    Drawer.propTypes = {
        show: Boolean,
        position: String
    };
    Drawer.defaultProps = {};
    Drawer = __decorate([
        omi_1.tag('m-drawer')
    ], Drawer);
    return Drawer;
}(omi_1.WeElement));
exports.default = Drawer;
